import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${Spacing.S24};
  margin-bottom: -${Spacing.S16};
`
